import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Send,
  CheckCircle,
  AlertTriangle,
  TrendingUp
} from "lucide-react";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 14px rgba(0,0,0,0.12)"
    }
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    "&:last-child": {
      paddingBottom: theme.spacing(2)
    }
  },
  value: {
    fontWeight: 700,
    fontSize: "1.75rem",
    lineHeight: 1.2
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    fontWeight: 500,
    marginTop: 2
  },
  iconWrapper: {
    width: 48,
    height: 48,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const KpiCards = ({ items = [], totalRegistros = 0, resumo = null }) => {
  const classes = useStyles();

  // Calcular métricas com base no resumo consolidado do filtro completo (se fornecido)
  const total =
    resumo?.total !== undefined ? resumo.total : totalRegistros || items.length;

  let sucessos = 0;
  let erros = 0;
  let taxaSucesso = 100;

  if (resumo && resumo.sucessos !== undefined && resumo.erros !== undefined) {
    sucessos = resumo.sucessos;
    erros = resumo.erros;
    taxaSucesso =
      resumo.taxa_sucesso !== undefined
        ? resumo.taxa_sucesso
        : sucessos + erros > 0
        ? Math.round((sucessos / (sucessos + erros)) * 100)
        : total > 0 && sucessos > 0
        ? Math.round((sucessos / total) * 100)
        : erros > 0
        ? 0
        : 100;
  } else {
    // Fallback: calcular métricas com base nos itens da listagem
    sucessos = items.filter(
      (i) =>
        i.status_envio === "sucesso" ||
        i.status_envio_label?.toLowerCase().includes("sucesso")
    ).length;
    erros = items.filter(
      (i) =>
        i.status_envio === "erro" ||
        i.status_envio_label?.toLowerCase().includes("erro")
    ).length;

    taxaSucesso =
      total > 0 && items.length > 0
        ? Math.round((sucessos / items.length) * 100)
        : 100;
  }

  const cardsData = [
    {
      label: "Total no Filtro",
      value: total,
      icon: Send,
      color: "#2563eb",
      bgColor: "rgba(37, 99, 235, 0.12)"
    },
    {
      label: "Envios com Sucesso",
      value: sucessos,
      icon: CheckCircle,
      color: "#16a34a",
      bgColor: "rgba(22, 163, 74, 0.12)"
    },
    {
      label: "Falhas / Erros",
      value: erros,
      icon: AlertTriangle,
      color: "#dc2626",
      bgColor: "rgba(220, 38, 38, 0.12)"
    },
    {
      label: "Taxa de Sucesso",
      value: `${taxaSucesso}%`,
      icon: TrendingUp,
      color: "#0891b2",
      bgColor: "rgba(8, 145, 178, 0.12)"
    }
  ];

  return (
    <Grid container spacing={2} style={{ marginBottom: 16 }}>
      {cardsData.map((card, idx) => {
        const IconComponent = card.icon;
        return (
          <Grid item xs={12} sm={6} md={3} key={idx}>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                <Box>
                  <Typography className={classes.value} style={{ color: card.color }}>
                    {card.value}
                  </Typography>
                  <Typography className={classes.label}>{card.label}</Typography>
                </Box>
                <Box
                  className={classes.iconWrapper}
                  style={{ backgroundColor: card.bgColor, color: card.color }}
                >
                  <IconComponent size={24} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default KpiCards;
